// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Paginación numérica reutilizable (Pedidos, Historial).
   Grises fijos: --button-color es por cuenta y puede ser claro, con texto blanco encima no se leería.
   Clases propias con prefijo \`pager-\` para no chocar con \`.pagination button\` de otras pantallas. */
.pager {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 24px;
  padding: 14px 18px;
  background: #fff;
  border-radius: 8px;
}

.pager-controls {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.pager .pager-nav,
.pager .pager-page {
  background: #fff;
  color: #333;
  border: 1px solid #d5d5d5;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;
}

.pager .pager-nav {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 16px;
  font-weight: 500;
}

.pager .pager-page {
  min-width: 36px;
  padding: 8px 10px;
  text-align: center;
}

.pager .pager-nav:hover:not(:disabled),
.pager .pager-page:hover:not(:disabled) {
  border-color: var(--button-color);
  color: var(--button-color);
  background: #fafafa;
}

.pager .pager-page.active {
  background: #f2f2f2;
  color: #000;
  font-weight: 600;
  border-color: #c9c9c9;
  box-shadow: inset 0 -2px 0 var(--button-color);
}

.pager .pager-nav:disabled,
.pager .pager-page:disabled {
  background: #fafafa;
  color: #c0c0c0;
  border-color: #ececec;
  cursor: not-allowed;
  opacity: 1;
}

.pager-ellipsis { color: #aaa; padding: 0 2px; }
.pager-arrow { font-size: 17px; line-height: 1; }
.pager-info { font-size: 14px; color: #666; }

@media (max-width: 760px) {
  .pager { flex-direction: column; align-items: stretch; }
  .pager-controls { justify-content: center; }
}
`, "",{"version":3,"sources":["webpack://./src/components/common/Pagination.css"],"names":[],"mappings":"AAAA;;oGAEoG;AACpG;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;EAEE,iCAAiC;EACjC,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,UAAU;AACZ;;AAEA,kBAAkB,WAAW,EAAE,cAAc,EAAE;AAC/C,eAAe,eAAe,EAAE,cAAc,EAAE;AAChD,cAAc,eAAe,EAAE,WAAW,EAAE;;AAE5C;EACE,SAAS,sBAAsB,EAAE,oBAAoB,EAAE;EACvD,kBAAkB,uBAAuB,EAAE;AAC7C","sourcesContent":["/* Paginación numérica reutilizable (Pedidos, Historial).\n   Grises fijos: --button-color es por cuenta y puede ser claro, con texto blanco encima no se leería.\n   Clases propias con prefijo `pager-` para no chocar con `.pagination button` de otras pantallas. */\n.pager {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-top: 24px;\n  padding: 14px 18px;\n  background: #fff;\n  border-radius: 8px;\n}\n\n.pager-controls {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n.pager .pager-nav,\n.pager .pager-page {\n  background: #fff;\n  color: #333;\n  border: 1px solid #d5d5d5;\n  border-radius: 8px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: border-color 0.15s ease, color 0.15s ease, background 0.15s ease;\n}\n\n.pager .pager-nav {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 8px 16px;\n  font-weight: 500;\n}\n\n.pager .pager-page {\n  min-width: 36px;\n  padding: 8px 10px;\n  text-align: center;\n}\n\n.pager .pager-nav:hover:not(:disabled),\n.pager .pager-page:hover:not(:disabled) {\n  border-color: var(--button-color);\n  color: var(--button-color);\n  background: #fafafa;\n}\n\n.pager .pager-page.active {\n  background: #f2f2f2;\n  color: #000;\n  font-weight: 600;\n  border-color: #c9c9c9;\n  box-shadow: inset 0 -2px 0 var(--button-color);\n}\n\n.pager .pager-nav:disabled,\n.pager .pager-page:disabled {\n  background: #fafafa;\n  color: #c0c0c0;\n  border-color: #ececec;\n  cursor: not-allowed;\n  opacity: 1;\n}\n\n.pager-ellipsis { color: #aaa; padding: 0 2px; }\n.pager-arrow { font-size: 17px; line-height: 1; }\n.pager-info { font-size: 14px; color: #666; }\n\n@media (max-width: 760px) {\n  .pager { flex-direction: column; align-items: stretch; }\n  .pager-controls { justify-content: center; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
